export default __webpack_public_path__ + "static/jessica-07ea365b840367a9f14e93ee41ed5db7.jpeg";